import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSavedView } from '../models/saved-view.model';
import { EUserRole } from '../../share/share-utils/user-roles';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { WorkspaceService } from '../../workspace/workspace.service';
import { SavedViewsService } from '../saved-views.service';

@Component({
  selector: 'pp-saved-view-preview-header',
  templateUrl: './saved-view-preview-header.component.html',
  styleUrls: ['./saved-view-preview-header.component.scss'],
  standalone: false,
})
export class SavedViewPreviewHeaderComponent {
  @Input() ppWorkspaceId: string;
  @Input() ppHideText = false;
  @Input() ppProcessing = false;
  @Output() ppSaveToCurrentView = new EventEmitter<void>();

  saveView: TSavedView;
  saveViewEditable: boolean;
  saveViewTooltipTitle: string;

  constructor(
    private savedViewsService: SavedViewsService,
    private workspaceService: WorkspaceService,
    private translationPipe: TranslationPipe,
  ) {}

  ngOnChanges(): void {
    const activeViewId = this.savedViewsService.getSelectedViewId(this.ppWorkspaceId);

    this.saveView = this.savedViewsService.getView(activeViewId);
    this.checkViewPermissions();
    this.generateTooltipTitle();
  }

  saveToCurrentView(): void {
    this.ppSaveToCurrentView.emit();
  }

  private checkViewPermissions(): void {
    const workspaceData = this.workspaceService.getWorkspace(this.ppWorkspaceId);

    if (!this.saveView) {
      this.saveViewEditable = false;
    } else {
      this.saveViewEditable =
        !workspaceData ||
        workspaceData.share?.shareOption === EUserRole.SITE_ADMIN ||
        workspaceData.share?.shareOption === EUserRole.OWNER ||
        workspaceData.share?.shareOption === EUserRole.ACCOUNT_ADMIN ||
        this.saveView.viewType === 'PERSONAL';
    }
  }

  private generateTooltipTitle(): void {
    if (this.saveView && this.saveViewEditable) {
      this.saveViewTooltipTitle = null;
    } else if (this.saveView && !this.saveViewEditable) {
      this.saveViewTooltipTitle = this.translationPipe.transform('view_update_permission_error');
    } else {
      this.saveViewTooltipTitle = this.translationPipe.transform('no_view_applied');
    }
  }
}
